<template>
  <div class="ticket">
    <span class="ticket__header">{{ticketDetail.accountName}}</span>
    <div class="ticket__content">
      <span class="ticket__content-header">
        恭喜您！收到一张<span style="color:#FF6A3C">优惠券</span>
      </span>
      <span class="ticket__content-tips">
        领券消费更优惠哦
      </span>
      <span class="ticket-content">
        <span class="ticket__amount">
          <span class="ticket__icon">￥</span>
          <span>{{ticketDetail.couponAmount}}</span>
        </span>
        <span class="ticket__rule">
          <span v-if="ticketDetail.ruleType"
                class="rule__content">无限制</span>
          <span v-else
                class="rule__content">满{{ticketDetail.consumeAmount}}元减{{ticketDetail.couponAmount}}元</span>
          <span v-if="ticketDetail.expireType"
                class="rule__time">激活后{{ticketDetail.activeExpireDays}}天</span>
          <span v-else
                class="rule__time">{{ticketDetail.expireTime}}到期</span>
        </span>
      </span>
      <span class="qrcode"></span>
    </div>
    <div class="input__box"
         v-if="!bind">
      <input type="tel"
             class="prepend-icon"
             maxlength="11"
             @input="validPhone=false"
             placeholder="请输入您的手机号码"
             @blur="resetScroll"
             v-model="formItem.phone">
      <input class="prepend-icon"
             maxlength="11"
             @input="validName=false"
             placeholder="请输入您的姓名"
             @blur="resetScroll"
             v-model="formItem.name">
    </div>
    <a href="javascript:void(0);"
       class="getNow"
       @click="getItNow"
       v-if="!bind">确认并领取优惠券</a>
    <a href="javascript:void(0);"
       class="getNow"
       v-else>已经领取</a>
  </div>
</template>
<script>
import Ticket from '../../model/ticket/index'
export default {
  name: 'ticket',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      Ticket: new Ticket(),
      formItem: {
        phone: '',
        name: ''
      },
      validName: false,
      validPhone: false,
      bind: false,
      ticketDetail: {}
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    this.getTicketDetail()
  },
  destroyed () { },
  methods: {
    testPhone (value) {
      return /^1\d{10}$/.test(value)
    },
    testNull (value) {
      return value && value.length !== 0
    },
    validatePhone () {
      if (!this.testNull(this.formItem.phone)) {
        this.$wejs.alert('手机号不能为空')
        this.validPhone = false
        return false
      }
      if (!this.testPhone(this.formItem.phone)) {
        this.$wejs.alert('请输入正确的手机号码')
        this.validPhone = false
        return false
      }
      this.validPhone = true
      return true
    },
    validateName () {
      if (!this.testNull(String.trim(this.formItem.name))) {
        this.$wejs.alert('姓名不能为空')
        this.validName = false
        return
      }
      this.validName = true
      return true
    },
    getItNow () {
      if (!this.validatePhone() || !this.validateName()) return
      this.getTicket()
    },
    getTicket () { // 领取票券
      let params = {
        couponRuleId: this.$route.query.couponRuleId,
        channel: 0,
        phone: this.formItem.phone,
        name: this.formItem.name
      }
      this.Ticket.getTicketNow(params).then(res => {
        if (res.result) {
          this.$wejs.alert('优惠券领取成功！')
          this.bind = true
        } else {
          this.$wejs.alert('优惠券已被领取')
          this.bind = true
        }
      }).catch(error => {
        this.$wejs.alert('优惠券领取失败')
        console.log(error)
      })
    },
    getTicketDetail () {
      // http://webapi.i200.cn/?modifierId=0&accountId=346543&couponRuleId=82
      let id = this.$route.query.couponRuleId
      this.Ticket.getTicketDetail(id).then(res => {
        this.ticketDetail = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    // ios 兼容，input失去焦点后界面上移不恢复的问题
    resetScroll () {
      setTimeout(() => {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base/_mixin';
@import '../../assets/scss/base/config';
.ticket {
  width: 100%;
  height: 100vh;
  background: radial-gradient(at center 30%, #ffb114, #ff5447);
  &__header {
    height: px2rem(50px);
    font-size: px2rem(36px);
    color: white;
    display: block;
    padding-top: px2rem(30px);
    text-align: center;
    line-height: px2rem(50px);
    margin: 0 auto;
  }
  &__content {
    width: px2rem(656px);
    height: px2rem(466px);
    margin: px2rem(20px) auto;
    background-color: white;
    border-radius: px2rem(12px);
    .ticket__content-header {
      height: px2rem(50px);
      display: block;
      line-height: px2rem(50px);
      text-align: center;
      font-size: px2rem(36px);
      color: black;
      padding-top: px2rem(40px);
      margin: 0 auto;
    }
    .ticket__content-tips {
      text-align: center;
      height: px2rem(40px);
      display: block;
      margin: 0 auto;
      padding-top: px2rem(10px);
      color: #999999;
      font-size: px2rem(28px);
    }
    .ticket-content {
      width: px2rem(596px);
      height: px2rem(176px);
      display: flex;
      margin: 0 auto;
      padding-top: px2rem(12px);
      background: url('../../assets/images/ticket/ticketbg.png') no-repeat;
      background-size: contain;
    }
    .qrcode {
      width: px2rem(582px);
      height: px2rem(86px);
      padding-top: px2rem(22px);
      background: url('../../assets/images/ticket/qrcode.png') no-repeat;
      background-size: contain;
      display: block;
      margin: 0 auto;
    }
  }
  &__amount {
    color: white;
    font-size: px2rem(32px);
    display: inline-block;
    height: px2rem(156px);
    width: px2rem(190px);
    padding-top: px2rem(20px);
    padding-left: px2rem(10px);
    overflow: hidden;
    position: relative;
    span {
      font-size: px2rem(84px);
      line-height: 1;
      position: absolute;
      left: px2rem(40px);
    }
  }
  &__icon {
    font-size: px2rem(32px) !important;
    line-height: 1;
    left: px2rem(10px) !important;
    position: absolute;
    top: px2rem(30px) !important;
  }
  &__rule {
    height: px2rem(156px);
    width: px2rem(360px);
    padding-top: px2rem(20px);
    display: inline-block;
    overflow: hidden;
  }
  .getNow {
    width: px2rem(658px);
    height: px2rem(88px);
    line-height: px2rem(88px);
    text-align: center;
    font-size: px2rem(30px);
    color: #ff6a3c;
    display: block;
    background-color: white;
    border-radius: px2rem(12px);
    margin: px2rem(60px) auto 0;
    text-decoration: none;
  }
  .input__box {
    width: px2rem(658px);
    height: px2rem(196px);
    margin: px2rem(24px) auto 0;
  }
  .prepend-icon {
    margin-bottom: px2rem(20px);
    width: px2rem(638px);
    height: px2rem(88px);
    border-radius: px2rem(12px);
    background-color: rgba(0, 0, 0, 0);
    border: 1px solid rgba(255, 255, 255, 1);
    color: white;
    padding-left: px2rem(20px);
    font-size: px2rem(32px);
  }
  .prepend-icon::placeholder {
    color: white;
    padding-left: px2rem(20px);
    font-size: px2rem(32px);
  }
}
.rule__content {
  color: white;
  font-size: px2rem(28px);
  display: block;
}
.rule__time {
  color: white;
  display: block;
  font-size: px2rem(20px);
}
</style>



// WEBPACK FOOTER //
// index.vue?e2f5d528